import { useQuery } from "@tanstack/react-query";
import { useApiConfig } from "@visioni/a3s-client-api/app";
import type { AssetCameraKey, SiteId } from "@visioni/a3s-schema";
import { alarmScheduleHistoryQuery } from "../queries";
import type { ISODateString } from "@visioni/a3s-codecs";

export type UseAlarmScheduleHistoryInput = {
  readonly siteId: SiteId;
  readonly assetCameraKey: AssetCameraKey;
  readonly from: ISODateString;
  readonly to: ISODateString;
  readonly enabled?: boolean;
};

/**
 * Fetches the history of applied schedules for a camera within a time range.
 * Returns the list of schedule versions that were active during the range,
 * each annotated with its active period.
 */
export function useAlarmScheduleHistory(input: UseAlarmScheduleHistoryInput) {
  const apiConfig = useApiConfig();
  const { siteId, assetCameraKey, from, to, enabled = true } = input;

  return useQuery({
    ...alarmScheduleHistoryQuery(apiConfig, { siteId, assetCameraKey }, { from, to }),
    enabled,
    staleTime: 60_000,
  });
}
